export const INDEX_ROUTE = `/`;
export const LOGIN_ROUTE = `/login`;
export const RESTAURANTS_ROUTE = `/restaurants`;
export const RESTAURANTS_ADD_ROUTE = `/restaurants/create`;
export const RESTAURANTS_EDIT_ROUTE = `/restaurants/edit`;
export const RESTAURANTS_COPY_ROUTE = `/restaurants/copy`;
export const RESTAURANTS_STATISTICS_ROUTE = `/restaurants/statistics`;
export const STATISTICS_RRPP_ROUTE = '/restaurants/statistics/rrpp'
export const TICKETS_ROUTE = `/restaurants/orders`;
export const TICKET_ADD_ROUTE = `/restaurants/orders/create`;
export const TICKET_EDIT_ROUTE = `/restaurants/orders/edit`;
export const TICKET_TYPES_ROUTE = `/restaurants/ticketTypes`;
export const TICKET_TYPE_ADD_ROUTE = `/restaurants/ticketTypes/create`;
export const TICKET_TYPE_EDIT_ROUTE = `/restaurants/ticketTypes/edit`;
export const MENU_CATEGORY_ROUTE = `/restaurants/categories`;
export const MENU_CATEGORY_ADD_ROUTE = `/restaurants/categories/create`;
export const MENU_CATEGORY_EDIT_ROUTE = `/restaurants/categories/edit`;
export const USERS_ROUTE = `/users`;
export const DELIVERYS_ROUTE = `/deliveryBoys`;
export const PLACES_ROUTE = `/places`;
export const PLACES_ADD_ROUTE = `/places/create`;
export const PLACES_EDIT_ROUTE = `/places/edit`;
export const NEWS_ROUTE = `/news`;
export const NEWS_ADD_ROUTE = `/news/create`;
export const NEWS_EDIT_ROUTE = `/news/edit`;
export const NOTIFICATIONS_ROUTE = `/notifications`;
export const NOTIFICATIONS_ADD_ROUTE = `/notifications/create`;
export const NOTIFICATIONS_EDIT_ROUTE = `/notifications/edit`;
export const RESERVATIONS_ROUTE = `/restaurants/reservations`;
export const DDJJ_ROUTE = `/ddjj`;
export const UNAUTHORIZED_ROUTE = '/unauthorized'
// export const PASSWORD_RECOVERY = `/passwordrecovery`;





// WEBPACK FOOTER //
// ./src/config/RoutesConstants.js